import { render, staticRenderFns } from "./newGameDailyLimit.vue?vue&type=template&id=467b57c4&"
import script from "./newGameDailyLimit.vue?vue&type=script&lang=js&"
export * from "./newGameDailyLimit.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./newGameDailyLimit.vue?vue&type=style&index=1&id=467b57c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports